import keyBy from 'lodash/keyBy';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { uiStateSelector } from 'state/selectors/ui-state';
import useMetricsCalculationConfig from '../../../hooks/useMetricsCalculationConfig';
import {
  GRANULARITY,
  GRANULARITY_TO_METRICS_V2_GRANULARITY
} from '../../performance/views/CustomReport/consts';
import { getFormattedAndCalculatedV3Data } from '../GroupDashboard/groupDashboard.service';
import { getMappedData } from './AllContributorsDoraDashboard.formatter';
import { getGroupWidgets } from './Widgets/widgets.definition';
import useMetrics from './useMetrics';
import { pmToolSensorIdSelector } from 'state/selectors/sensors-authorizations';
import { INCIDENTS_STRATEGIES, SettingValues } from '@linearb/linjs-common';
import useSettingsService from 'components/hooks/useSettingsService';

const useWidgetDataCalculation = ({
  isLodingCycleTimeData,
  reposProcessPercentage
}) => {
  const { getSettingOrDefinitionValue } = useSettingsService();
  const pmToolSensorId = useSelector(pmToolSensorIdSelector);
  const incidentsStrategy = getSettingOrDefinitionValue({
    name: SettingValues.INCIDENTS_STRATEGY
  });

  const isReportedIncidentsStrategy =
    incidentsStrategy?.key === INCIDENTS_STRATEGIES.REPORTED;

  const shouldShowCFRMTTR = isReportedIncidentsStrategy || pmToolSensorId;
  const groupWidgets = getGroupWidgets(shouldShowCFRMTTR);

  const uiState = useSelector(uiStateSelector);
  const { dates, selectedTeamId } = uiState;

  const [metricsWidgetData, setMetricsWidgetData] = useState([]);
  const metricsCalculationConfig = useMetricsCalculationConfig();
  const { metricsCalculationStrategy } = metricsCalculationConfig;

  const widgetsMetricsNames = groupWidgets
    .filter(widget => widget.metricName)
    .map(widget => widget.metricName);

  const { isLoading, metrics } = useMetrics({
    dates,
    metricsCalculationStrategy,
    selectedTeamId,
    widgetsMetricsNames,
    isAggregatedMetrics: true,
    fetchDependency: reposProcessPercentage
  });

  const granularity = GRANULARITY.WEEKS;
  // https://linearb.atlassian.net/browse/LINBEE-3570
  // getGranularityByDates({
  //   start_date: dates.from,
  //   end_date: dates.to,
  //   selectedGranularity: GRANULARITY.AUTO
  // });
  const {
    isLoading: metricsPerGranularityLoading,
    metrics: metricsPerGranularity
  } = useMetrics({
    dates,
    metricsCalculationStrategy,
    selectedTeamId,
    roll_up: GRANULARITY_TO_METRICS_V2_GRANULARITY[granularity],
    widgetsMetricsNames,
    fetchDependency: reposProcessPercentage
  });

  const { mappedV3Data, metricsPerGranularityMapped } = getMappedData(
    metrics,
    metricsPerGranularity,
    selectedTeamId
  );

  const { formattedV3Data, V3DataCalculated } = getFormattedAndCalculatedV3Data(
    mappedV3Data,
    widgetsMetricsNames,
    metricsWidgetData,
    metricsPerGranularityMapped
  );

  const metricsWidgetsByName = keyBy(metricsWidgetData, 'metrics[0].name');

  const isWidgetLoading =
    !widgetsMetricsNames.length ||
    isLoading ||
    metricsPerGranularityLoading ||
    isLodingCycleTimeData;

  return {
    widgets: groupWidgets.map(widget => {
      return {
        metricName: widget.metricName,
        gridSize: widget.gridSize,
        GridItem: widget.GridItem,
        Component: widget.Component
      };
    }),
    widgetsMetricsNames,
    metricsWidgetData,
    setMetricsWidgetData,
    selectedTeamId,
    formattedV3Data,
    V3DataCalculated,
    isWidgetLoading,
    metricsPerGranularityMapped,
    metricsWidgetsByName
  };
};

export default useWidgetDataCalculation;
